module.exports = __webpack_public_path__ + "img/dolki.a7a48788.png";